<template>
<div class="container-fluid bg-white">
	<equipment-toolbar heading="Equipment Apps"></equipment-toolbar>

	<addon-app-tab ui-location="Equipment Module"></addon-app-tab>
</div>
</template>
<script type="text/javascript">
import EquipmentToolbar from "./EquipmentToolbar"
import AddonAppTab from "@/components/AddonAppTab"

export default {
	name: "EquipmentApps",
	components: {
		EquipmentToolbar,
		AddonAppTab
	}
}
</script>